import React from 'react'
import { Flex, Image, Layout, Space, Watermark } from 'antd';
import styles from './index.module.less';
import Avatar from './avatar';
import GlobalLan from './global-lan';
import Logo from './logo';
import useStore from '@/hooks/use-store';
import { ALL_APP_CONFIGS } from '@/pages/sub-app/config';
import { useNavigate } from 'react-router';
import classNames from 'classnames';
import { RoutePath } from '@/routes/enum';

const { Header:AntdHeader } = Layout;

export const HEADER_LINKS = [
  {
    label: '驾驶舱',
    path: RoutePath.DASHBOARD
  }, 
  {
    label: '工具箱',
    path: RoutePath.GUIDE
  }
]

const Header = () => {
  const navigate = useNavigate();

  const {
    headerStyle,
    setHeaderStyle,
    setCurrentSubAppKey,
    currentSubAppKey,
  } = useStore()

  return (
    <AntdHeader 
      className={styles['main-header']} 
      style={{
        right: headerStyle === 'system' ? 0 : '50%',
      }}
    >
      <Flex>
        <Logo />
        <Flex className={styles.apps} gap={10}>
          <div className={styles['main-header-link']}>
            {HEADER_LINKS.map(c => (
              <div
                key={c.path}
                className={styles['main-header-link-item']}
                style={{
                  color: location.pathname.includes(c.path) ? '#5982EE' : '#A3AFC7',
                }}
                onClick={() => navigate(c.path)}
              >{c.label}</div>
            ))}
          </div>
        </Flex>
      </Flex>
      {headerStyle === 'system' && (
        <Space direction="horizontal" align="center">
          {/* <GlobalLan /> */}
          <Avatar />
        </Space>
      )}
    </AntdHeader>
  )
}
export default React.memo(Header)